import logo from "../../assets/images/HexaLogo.png";

import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        width: "100%",
        padding: "10px 10px",
        background: "#f1f1f1",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}
    >
      <span>
        Desarrollado por Hexagons Tech SRL © 2026 - Todos los derechos reservados
      </span>

      <img
        src={logo}
        alt="Hexagons Tech"
        style={{ height: "30px" }}
      />
    </div>
  );
};

export default Footer;